/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { IPatientCategory } from 'app/shared/model/patient-category.model';
import { IHospitalPayment } from 'app/shared/model/hospital-payment.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';
import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IHospitalBillItem {
  id?: string;
  descreption?: string | null;
  remainingQty?: number | null;
  rate?: number | null;
  discountRate?: number | null;
  marginRate?: number | null;
  netRate?: number | null;
  grossValue?: number | null;
  discount?: number | null;
  tax?: number | null;
  netValue?: number | null;
  taxPlusNetValue?: number | null;
  marginValue?: number | null;
  adjustedValue?: number | null;
  billType?: keyof typeof BillType | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  miscellaneous?: boolean;
  multiplier?: number | null;
  paymentMethod?: keyof typeof PaymentMethod | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  roundOffVal?: number | null;
  chargedItem?: string | null;
  bill?: IHospitalBill | null;
  patientCategory?: IPatientCategory | null;
  hospitalPayment?: IHospitalPayment | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IHospitalBillItem> = {
  active: false,
  miscellaneous: false,
};
